<script lang="ts">
	import { page } from '$app/stores';
	import NotFoundScreen from '$lib/components/errors/NotFoundScreen.svelte';
</script>

{#if $page.status == 404}
	<NotFoundScreen />
{:else}
	<h1>{$page.status}</h1>
	<p>{$page.error?.message}</p>
{/if}
